import React, { Suspense } from 'react';
import SelectedElementsLayer from './selected-element-layer/selected-elements-layer';
import AdsorbConnectElements from './components/connected-elements/adsorb-connect-elements';
import ErrorBoundary from '../../../../../../../frame/components/error-boundary';
import AnimTipsContainer from './components/anim-tips-container';
import CursorBorder from './components/cursor-border/cursor-border';
import HighlightBorder from './components/highlight-border';
import { SnapLines } from '@src/slide/application/service/snap-line-service/render/snap-line';
import { ServicesContext } from '@editor/src/page/index/components/canvas/edit-panel/context';
import { pcSnapLineStyleSheet } from '@src/slide/application/service/snap-line-service/render/style-sheet';
import CommentBorder from './components/comment-border/pc';
import { EDIT_PANEL_ID } from '../canvas-constants';

interface IEditPanelPcProps {
    scale: number;
    slideAreaSize: {
        width: number;
        height: number;
        top: number;
        left: number;
    };
}

/**
 * 选中框等编辑外框都放到这个面板上面，面板上按照元素顺序来渲染每个元素的编辑外框
 */
export default class EditPanelPc extends React.Component<IEditPanelPcProps> {
    static contextType = ServicesContext;

    public shouldComponentUpdate(nextProps: IEditPanelPcProps): boolean {
        if (nextProps.scale !== this.props.scale) {
            return true;
        }
        return false;
    }

    public render() {
        return (
            <div
                id={EDIT_PANEL_ID}
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    zIndex: 1,
                    pointerEvents: 'none',
                }}
            >
                <CommentBorder
                    slideAreaSize={this.props.slideAreaSize}
                    scale={this.props.scale}
                />
                <SelectedElementsLayer
                    scale={this.props.scale}
                />
                <AdsorbConnectElements
                    scale={this.props.scale}
                />
                {
                    <ErrorBoundary>
                        <Suspense fallback={<div/>}>
                            <SnapLines
                                // pc的外层容器会做transform，不需要里面进行scale计算
                                // 组件是 PC/M 通用的，所以pc这里传1来实现组件自身不进行scale缩放
                                scale={{ frameScale: 1, graphicScale: this.props.scale }}
                                snapLineService={this.context.snapLineService}
                                styleSheet={pcSnapLineStyleSheet}
                            />
                        </Suspense>
                    </ErrorBoundary>
                }
                <AnimTipsContainer scale={this.props.scale} />
                <CursorBorder scale={this.props.scale} />
                <HighlightBorder />
            </div>
        );
    }
}
